import React, { useState, useContext } from "react";
import { LanguageContext } from "../LanguageContext/LanguageContext";
import styles from "./FilmProductionInstructor.module.css";

const FilmProductionInstructor = ({
  CourseInstructorName,
  CourseInstructorDetails,
  CourseInstructorPhoto,
}) => {
  const { direction } = useContext(LanguageContext);
  const [isOpen, setIsOpen] = useState(false);
  const toggleContent = () => setIsOpen(!isOpen);

  const collapsibleClass =
    direction === "rtl" ? styles.collapsibleRtl : styles.collapsibleLtr;

  return (
    <div
      style={{
        background: `linear-gradient(0deg, rgba(10, 23, 31, 0.70) 0%, rgba(10, 23, 31, 0.70) 100%), url(${CourseInstructorPhoto}) lightgray 50% / cover no-repeat`,
      }}
      className={styles.maincontainer}
    >
      <div className={collapsibleClass}>
        <div className={styles.header}>
          <div onClick={toggleContent} className={styles.toggleButton}>
            {isOpen ? "-" : "+"}
          </div>

          {/* Render Instructor Title */}
          {CourseInstructorName && CourseInstructorName.length > 0 ? (
            <h5 className={styles.toggle}>
              {direction === "rtl" ? "عن المدرب" : "About the Instructor"}
            </h5>
          ) : (
            ""
          )}

          <hr className={styles.line} />
        </div>

        {isOpen && CourseInstructorName && (
          <div className={styles.instructorContent}>
            {/* Display instructor name and photo */}
            {CourseInstructorName && (
              <h6 className={styles.instructorName}>{CourseInstructorName}</h6>
            )}

            <p className={styles.paragraph}>{CourseInstructorDetails}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilmProductionInstructor;
